import * as React from "react";

function SvgDinoCoding(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 840 797"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      {...props}
    >
      <circle
        cx={1057.35}
        cy={1737.7}
        r={413.85}
        fill="#ffeee9"
        transform="matrix(.96237 0 0 .96247 -576.163 -1274.17)"
      />
      <path
        d="M258.694 1046.24c-5.263-114.531 56.797-218.043 170.267-284.711"
        fill="none"
        stroke="#66a09e"
        strokeWidth={8.8}
        transform="matrix(.73477 .33486 -.4147 .90995 282.77 -672.44)"
      />
      <path
        d="M322.349 157.014c-.097 4.377-13.873 10.066-25.239 11.838-11.366 1.773-16.046-1.04-15.95-5.415.097-4.377 4.934-8.673 16.3-10.445 11.366-1.773 24.986-.355 24.889 4.022zM278.216 192.55c-1.6 4.208-16.726 2.9-28.2-1.022-11.473-3.92-13.444-11.567-11.844-15.776 1.6-4.208 6.17-3.394 17.644.527 11.473 3.92 24 12.063 22.4 16.271zM226.307 208.129c-.685 4.922-18.066 8.933-32.027 8.944-13.962.012-18.212-7.203-17.528-12.126.685-4.923 6.046-5.701 20.008-5.713 13.962-.011 30.232 3.972 29.547 8.895zM178.06 245.798c-.311 5.231-20.157 11.573-36.414 13.31-16.258 1.738-21.919-5.28-21.607-10.513.312-5.233 6.48-6.71 22.737-8.447 16.258-1.737 35.597.417 35.285 5.65z"
        fill="#66a09e"
      />
      <path
        d="M149.212 183.025c-3.504-2.079-17.36 16.477-26.495 33.274-9.137 16.798-7.437 26.168-3.932 28.248 3.504 2.08 7.493-3.915 16.63-20.713 9.136-16.798 17.301-38.73 13.797-40.809zM79.496 236.162c-4.182-.075-10.997 22.236-13.834 40.798-2.836 18.564 2.23 25.659 6.413 25.734 4.183.074 5.908-6.9 8.745-25.463 2.837-18.563 2.86-40.994-1.324-41.069z"
        fill="#66a09e"
      />
      <path
        d="M128.134 278.501c1.171 4.416-16.59 17.545-32.118 25.464-15.529 7.918-23.09 4.422-24.263.006-1.172-4.417 4.487-8.091 20.016-16.01 15.528-7.919 35.193-13.876 36.365-9.46zM100.707 332.266c1.673 4.501-18.033 21.474-35.512 32.523-17.48 11.05-26.513 8.608-28.187 4.105-1.674-4.502 4.64-9.368 22.12-20.419 17.48-11.05 39.904-20.711 41.579-16.209z"
        fill="#66a09e"
      />
      <path
        d="M26.777 297.894c-4.516 1.543-5.083 27.588-2.512 48.158 2.572 20.573 10.163 26.051 14.68 24.508 4.516-1.544 4.259-9.528 1.687-30.1-2.572-20.57-9.338-44.11-13.855-42.566zM214.633 154.41c-2.64-3.302-18.706 9.068-30.258 21.557-11.552 12.49-12.028 22.032-9.387 25.334 2.641 3.302 7.404-.879 18.956-13.368 11.552-12.49 23.33-30.221 20.69-33.524zM274.713 135.518c-2.104-3.205-16.508 6.103-27.043 15.984-10.535 9.883-11.414 18.301-9.31 21.506 2.105 3.205 6.4-.01 16.936-9.892 10.534-9.882 21.522-24.393 19.417-27.598z"
        fill="#66a09e"
      />
      <g>
        <path
          d="M265.491 969.548c27.337-79.062 84.759-152.083 163.47-208.019"
          fill="none"
          stroke="#bcdad1"
          strokeWidth={8}
          transform="matrix(.97087 -.23958 .23958 .97087 -445.264 -512.244)"
        />
        <path
          d="M185.834 94.627c2.845 3.175-6.213 15.939-15.646 24.39-9.433 8.453-15.692 9.414-18.537 6.24-2.845-3.176-1.206-9.293 8.227-17.745 9.433-8.452 23.111-16.06 25.956-12.885zM172.473 146.256c1.702 4.173-13.645 14.383-27.526 20.043s-21.6 1.67-23.302-2.504c-1.702-4.174 3.254-6.96 17.135-12.62 13.881-5.66 31.991-9.093 33.693-4.919zM133.37 195.997c3.39 4.348-9.788 20.301-23.007 30.609-13.219 10.309-23.166 7.812-26.557 3.463-3.39-4.348 1.051-8.91 14.27-19.22 13.219-10.307 31.902-19.2 35.293-14.852zM117.989 264.277c2.655 4.724-15.479 19.965-32.315 29.429-16.836 9.464-27.066 6.097-29.722 1.373-2.656-4.725 3.263-9.029 20.1-18.493 16.835-9.464 39.281-17.033 41.937-12.309z"
          fill="#bcdad1"
        />
        <path
          d="M27.487 237.289c-4.408 2.435 3.174 24.61 12.435 41.367 9.26 16.759 19.209 19.494 23.617 17.058 4.408-2.436 1.615-9.125-7.645-25.884-9.26-16.758-24-34.977-28.407-32.541zM2.247 320.441c-4.795 3.527 4.985 24.978 16.33 40.402 11.346 15.423 22.647 16.056 27.442 12.528 4.795-3.527 1.28-9.886-10.066-25.31-11.345-15.423-28.911-31.147-33.706-27.62z"
          fill="#bcdad1"
        />
        <path
          d="M91.25 318.826c4.883 3.8-6.038 26.01-18.389 41.879-12.351 15.87-24.16 16.269-29.043 12.468-4.883-3.8-1.002-10.37 11.35-26.24 12.35-15.869 31.2-31.908 36.082-28.107zM75.377 167.781c-5.043.166-8.448 21.323-7.875 38.766.574 17.444 8.186 23.766 13.23 23.6 5.045-.166 5.622-6.756 5.049-24.2-.573-17.444-5.36-38.331-10.404-38.166zM114.166 111.69c-5.2.598-7.359 19.031-5.646 33.923 1.713 14.893 9.984 19.62 15.185 19.022 5.2-.598 5.374-6.296 3.66-21.19-1.712-14.891-7.998-32.353-13.2-31.755z"
          fill="#bcdad1"
        />
      </g>
      <g>
        <path
          d="M301.069 875.229c31.852-43.312 76.206-79.182 127.892-113.7"
          fill="none"
          stroke="#66a09e"
          strokeWidth={7.82}
          transform="matrix(.33321 -.69155 .69155 .33321 -625.565 483.184)"
        />
        <path
          d="M43.574 416.67c3.964-.157 7.542 8.758 7.84 16.262.298 7.504-2.797 10.773-6.76 10.93-3.966.157-7.31-2.856-7.607-10.36-.298-7.503 2.562-16.674 6.527-16.831zM67.145 450.361c3.494 2.133.316 13.717-4.675 21.891-4.99 8.175-11.993 8.123-15.487 5.99-3.495-2.134-2.166-5.545 2.825-13.72 4.99-8.175 13.842-16.294 17.337-14.16zM80.197 487.186c3.484 1.747.13 15.49-5 25.714-5.13 10.226-12.17 11.511-15.653 9.763-3.484-1.748-2.101-5.87 3.029-16.096 5.13-10.225 14.14-21.13 17.624-19.381zM96.952 526.762c4.59 1.578 3.263 17.564-.932 29.765-4.194 12.202-12.505 14.479-17.096 12.9-4.591-1.578-3.734-6.417.46-18.62 4.195-12.2 12.977-25.623 17.568-24.045z"
          fill="#66a09e"
        />
        <path
          d="M37.123 556.707c-1.47 4.534 12.42 13.105 24.935 17.162 12.516 4.058 19.382-1.065 20.852-5.6 1.47-4.536-3.009-6.776-15.525-10.833-12.515-4.057-28.792-5.264-30.262-.73zM25.95 498.937c-2.516 3.531 7.341 14.874 17.215 21.907 9.874 7.033 17.278 4.5 19.794.969 2.516-3.532-.804-6.734-10.679-13.767-9.873-7.033-23.815-12.641-26.33-9.11zM27.684 453.395c-2.99 2.279 1.811 13.613 7.809 21.483 5.998 7.87 12.64 7.49 15.63 5.211s1.202-5.598-4.796-13.469c-5.997-7.87-15.653-15.504-18.643-13.225z"
          fill="#66a09e"
        />
      </g>
      <g>
        <path
          d="M258.694 1046.24c-5.263-114.531 56.797-218.043 170.267-284.711"
          fill="none"
          stroke="#66a09e"
          strokeWidth={9.04}
          transform="matrix(.4421 -.0111 .0111 .4421 597.514 76.952)"
        />
        <path
          d="M813.762 398.153c.99 1.755-4.46 6.71-9.65 9.638-5.19 2.93-8.168 2.731-9.158.976-.99-1.754.379-4.405 5.569-7.334 5.19-2.93 12.248-5.034 13.239-3.28zM800.405 420.89c.209 1.982-7.568 4.426-14.161 5.118-6.594.692-9.38-1.954-9.588-3.937-.208-1.982 2.24-2.554 8.834-3.247 6.593-.692 14.707.084 14.915 2.066zM778.478 437.235c.83 2.087-6.8 7.081-13.688 9.82-6.889 2.74-10.698.71-11.527-1.376-.83-2.087 1.632-3.445 8.521-6.184 6.889-2.74 15.864-4.346 16.694-2.26zM763.597 461.624c1.086 2.136-7.206 8.538-14.818 12.41-7.613 3.874-12.072 2.199-13.158.063-1.087-2.137 1.607-3.93 9.22-7.803 7.612-3.873 17.669-6.807 18.756-4.67z"
          fill="#66a09e"
        />
        <path
          d="M734.47 442.379c-2.223-.138-4.661 9.934-5.187 18.385-.526 8.452 2.535 11.835 4.758 11.973 2.223.139 2.77-3.02 3.297-11.472.525-8.45-.645-18.748-2.868-18.886zM712.66 477.107c-2.082.79-.155 10.972 2.847 18.89 3.002 7.917 7.186 9.739 9.268 8.949 2.083-.79 1.28-3.893-1.722-11.811-3.002-7.917-8.31-16.818-10.393-16.028z"
          fill="#66a09e"
        />
        <path
          d="M746.708 484.372c1.626 1.522-4.028 10.207-9.814 16.389-5.787 6.182-10.349 6.276-11.975 4.754-1.626-1.522.296-4.087 6.083-10.27 5.787-6.18 14.08-12.395 15.706-10.873zM745.921 511.066c1.894 1.458-3.808 12.048-9.815 19.854-6.008 7.806-11.046 8.606-12.94 7.148-1.894-1.457.069-4.624 6.077-12.43 6.007-7.806 14.784-16.03 16.678-14.572z"
          fill="#66a09e"
        />
        <path
          d="M701.278 511.914c-1.863 1.497 4.033 11.937 10.181 19.591 6.149 7.655 11.195 8.341 13.058 6.845 1.864-1.497-.157-4.613-6.306-12.268-6.148-7.654-15.07-15.664-16.933-14.168zM759.975 418.217c-2.086-.792-7.082 7.26-9.823 14.476-2.74 7.216-.711 11.093 1.375 11.885 2.087.793 3.446-1.798 6.187-9.014 2.74-7.215 4.348-16.555 2.261-17.347zM785.15 398.958c-1.798-.859-6.7 5.653-9.557 11.636-2.857 5.982-1.294 9.493.505 10.352s3.157-1.257 6.013-7.24c2.857-5.982 4.839-13.89 3.04-14.748z"
          fill="#66a09e"
        />
        <g>
          <path
            d="M346.698 824.823c19.134-24.24 45.947-45.28 82.263-63.294"
            fill="none"
            stroke="#bcdad1"
            strokeWidth={5.21}
            transform="matrix(.76702 -.0307 .0307 .76703 436.37 -124.864)"
          />
          <path
            d="M801.068 438.262c1.047 2.027-2.668 6.651-6.455 9.123-3.788 2.472-6.223 1.862-7.27-.165-1.047-2.027-.311-4.708 3.476-7.18 3.788-2.472 9.202-3.805 10.25-1.778zM792.354 457.238c-.297 2.482-7.068 4.255-12.486 4.055-5.418-.2-7.022-3.916-6.725-6.398.298-2.482 2.383-2.797 7.802-2.597 5.418.2 11.706 2.458 11.41 4.94zM778.426 469.326c-.05 2.363-7.936 4.849-14.446 5.32-6.51.47-8.887-2.818-8.836-5.181.05-2.363 2.508-2.912 9.018-3.383 6.51-.47 14.315.881 14.264 3.244zM762.337 484.42c.306 2.89-8.241 7.128-15.54 8.699-7.298 1.57-10.495-2.078-10.801-4.968-.307-2.89 2.392-3.936 9.69-5.506 7.3-1.57 16.344-1.116 16.65 1.774z"
            fill="#bcdad1"
          />
          <path
            d="M730.722 461.341c-2.69.63-3.716 10.547-2.754 18.35.962 7.805 5.27 9.818 7.962 9.187 2.69-.63 2.752-3.666 1.79-11.47-.962-7.804-4.306-16.697-6.998-16.067zM755.588 444.467c-2.436-.128-5.44 8.024-6.29 14.875-.85 6.851 2.403 9.618 4.84 9.747 2.437.13 3.14-2.429 3.99-9.28.85-6.851-.103-15.213-2.54-15.342zM773.795 436.82c-2.083-.11-4.158 6.01-4.475 11.162-.317 5.152 2.62 7.25 4.704 7.36 2.084.109 2.531-1.813 2.849-6.965.317-5.151-.993-11.449-3.078-11.558z"
            fill="#bcdad1"
          />
        </g>
      </g>
      <g transform="matrix(-.86526 0 0 .12072 1280.364 438.513)">
        <circle cx={947.823} cy={1589.94} r={346.998} fillOpacity={0.25} />
      </g>
      <g>
        <path
          d="M393.652 231.75c-2.338-20.624 27.126-50.479 36.126-55.055 8.966-4.558 23.897 18.425 17.876 27.602-6.021 9.175-52.944 33.15-54.002 27.453z"
          fill="#fd6a66"
        />
        <path
          d="M421.231 219.152c-.903-8.863 35.355-65.583 60.524-63.685 11.062.835 15.503 42.563 5.417 53.178-10.087 10.613-65.038 19.37-65.94 10.507z"
          fill="#fd6a66"
        />
        <path
          d="M258.938 511.741c-4.176-5.126-51.994-17.123-63.63-3.662-5.114 5.916 14.454 30.145 25.06 30.756 10.604.61 42.747-21.967 38.57-27.094z"
          fill="#fd6b67"
        />
        <path
          d="M300.268 478.89c-4.592-6.222-59.155-23.614-73.13-8.961-6.142 6.44 15.363 35.83 27.551 37.325 12.188 1.493 50.17-22.143 45.579-28.365z"
          fill="#fd6b67"
        />
        <path
          d="M336.77 454.332c-3.388-7.083-54.054-35.19-70.549-23.443-7.25 5.162 8.57 38.587 20.33 42.494 11.757 3.907 53.608-11.968 50.22-19.05zM183.339 564.688c-2.896-2.987-34.186-6.893-41.145 2.784-3.058 4.252 10.518 18.385 17.376 17.921 6.857-.464 26.665-17.718 23.769-20.705z"
          fill="#fd6b67"
        />
        <path
          d="M214.733 538.592c-3.654-3.75-42.759-9.027-51.314 2.902-3.76 5.243 13.376 22.987 21.928 22.504 8.552-.484 33.041-21.655 29.386-25.406z"
          fill="#fd6b67"
        />
        <path
          d="M153.584 592.687c-15.005-13.41 14.169-24.596 39.193-44.672 27.695-22.22 86.35-63.348 94.873-111.005 4.195-23.45 96.712 132.3 81.179 150.364-51.057 58.827-155.735 58.499-215.245 5.313z"
          fill="#fe9f9c"
        />
        <g transform="matrix(-1.34581 -1.19246 .67004 -.7562 251.772 1470.04)">
          <clipPath id="dino_coding_svg___clip1">
            <path d="M364.457 585.486c11.192.086 3.174 27.521.162 58.819-3.333 34.638-12.579 103.606 1.45 144.504 6.903 20.125-89.051-34.526-89.248-58.104-.444-77.091 43.249-145.557 87.636-145.219z" />
          </clipPath>
          <g clipPath="url(#dino_coding_svg___clip1)">
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8c89"
              transform="matrix(-.26043 .19547 .2119 .28233 384.478 266.859)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8c89"
              transform="matrix(-.10663 .08003 .10961 .14604 349.845 469.878)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8c89"
              transform="matrix(-.13048 .09793 .13072 .17416 314.07 462.278)"
            />
          </g>
        </g>
        <path
          d="M291.675 595.757c10.707 70.062 406.485 69.456 415.075 0 10.189-82.382 3.493-186.566-1.556-214.875C686.707 277.25 604.478 188.09 499.212 187.56c-105.266.531-187.494 89.69-205.98 193.322-5.05 28.309-14.097 132.818-1.557 214.875z"
          fill="#feb4b2"
        />
        <g transform="matrix(-1 0 0 1 1042.525 -181.642)">
          <clipPath id="dino_coding_svg___clip2">
            <path d="M750.852 777.401c-10.707 70.062-406.486 69.456-415.076 0-10.189-82.382-3.493-186.567 1.556-214.876 18.487-103.632 100.716-192.791 205.982-193.322 105.266.531 187.495 89.69 205.981 193.322 5.05 28.309 14.097 132.819 1.557 214.876z" />
          </clipPath>
          <g clipPath="url(#dino_coding_svg___clip2)">
            <ellipse
              cx={360.123}
              cy={778.252}
              rx={39.216}
              ry={31.424}
              fill="#fea5a4"
            />
            <ellipse
              cx={393.895}
              cy={732.103}
              rx={14.973}
              ry={14.725}
              fill="#fea5a4"
              transform="matrix(.8931 .22682 -.18934 .74549 179.578 100.094)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(.29224 -.21806 .18986 .25445 415.949 644.57)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(.80454 .26865 -.30699 .91936 294.222 -426.227)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(.48475 .16186 -.14999 .44918 482.961 80.988)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(.34226 .10427 -.0859 .28195 504.375 487.89)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(.25025 -.12328 .13025 .2644 398.112 508.517)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(-.06356 .1502 -.17332 -.07334 823.797 676.675)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(-.13102 .09712 -.10695 -.14428 545.206 709.712)"
            />
            <ellipse
              cx={627.244}
              cy={866.811}
              rx={21.909}
              ry={27.526}
              fill="#fea5a4"
              transform="matrix(.65235 .75792 -.72807 .62665 687.227 -202.283)"
            />
            <ellipse
              cx={627.244}
              cy={866.811}
              rx={21.909}
              ry={27.526}
              fill="#fea5a4"
              transform="matrix(.32492 .3775 -.32718 .2816 599.351 320.652)"
            />
            <ellipse
              cx={627.244}
              cy={866.811}
              rx={21.909}
              ry={27.526}
              fill="#fea5a4"
              transform="matrix(.40888 .47506 -.32718 .2816 419.507 74.9)"
            />
            <ellipse
              cx={627.244}
              cy={866.811}
              rx={21.909}
              ry={27.526}
              fill="#fea5a4"
              transform="matrix(.31115 .36151 -.32718 .2816 689.051 282.876)"
            />
            <ellipse
              cx={522.817}
              cy={430.672}
              rx={20.488}
              ry={28.446}
              fill="#fea5a4"
              transform="matrix(1 0 0 1 -16.955 23.774)"
            />
            <ellipse
              cx={451.534}
              cy={438.87}
              rx={15.874}
              ry={8.198}
              fill="#fea5a4"
              transform="rotate(-22.303 439.673 456.456)"
            />
          </g>
        </g>
        <path
          d="M701.222 364.363c3.611 63.754-51.293 82.039-72.634 97.006-21.342 14.967-25.728 45.571-9.788 68.3 15.94 22.73 46.077 28.84 67.55 14.063 70.076-48.507 49.18-152.894 14.872-179.37z"
          fill="#fe9f9c"
        />
        <g transform="matrix(-.67602 -.96393 -.9051 .63476 1534.85 346.744)">
          <clipPath id="dino_coding_svg___clip3">
            <path d="M394.3 626.529c-46.095 30.439-32.034 80.597-32.034 104.176 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.444-77.091 82.337-115.833 117.479-104.176z" />
          </clipPath>
          <g clipPath="url(#dino_coding_svg___clip3)">
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8c89"
              transform="matrix(.39321 .24704 -.29062 .46258 212.856 187.004)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8c89"
              transform="matrix(.1823 .1438 -.11359 .14399 260.54 530.44)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8c89"
              transform="matrix(-.1277 .2162 -.24646 -.14557 614.536 599.312)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8c89"
              transform="matrix(-.07903 .1338 -.1462 -.08635 545.88 617.605)"
            />
          </g>
        </g>
        <g>
          <path
            d="M618.952 522.04c-2.056 2.311-16.09-1.699-17.027-5.058-.937-3.36 7.58-14.826 10.573-13.778 2.993 1.048 8.51 16.523 6.454 18.835zM619.998 525.527c-3.073.537-8.014 11.945-5.61 14.423 2.405 2.478 16.488 3.877 17.918-1.091.846-2.94-9.235-13.87-12.308-13.332zM636.667 541.267c-2.903 1.04-4.88 10.902-1.44 13.9 2.597 2.262 16.75-1.347 17.807-6.433.625-3.01-12.735-8.768-16.367-7.467z"
            fill="#fc4b48"
          />
        </g>
        <g>
          <path
            d="M307.768 385.15c8.94-3.514 19.787 38.868 39.642 51.357 36.595 23.017 87.75 30.773 105.709 33.606 27.421 4.327 46.173 30.102 41.847 57.524-4.327 27.423-30.068 45.944-57.525 41.847-59.97-9.108-119.332-41.153-138.558-91.884-11.209-29.577-7.284-86.097 8.885-92.45z"
            fill="#fea09d"
          />
          <g transform="scale(1.17736) rotate(-81.034 179.666 551.78)">
            <clipPath id="dino_coding_svg___clip4">
              <path d="M414.31 597.512c4.131 7.035-29.991 21.746-37.841 40.057-14.467 33.749-14.203 77.694-14.203 93.136 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.297-51.519 18.731-105.565 58.748-128.41 23.331-13.319 71.27-17.508 78.741-4.783z" />
            </clipPath>
            <g clipPath="url(#dino_coding_svg___clip4)">
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe8d8a"
                transform="matrix(-.09857 .60165 .5134 .08411 33.324 115.917)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe8d8a"
                transform="matrix(.16855 .18413 .1985 -.1817 106.803 598.18)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe8d8a"
                transform="matrix(-.2535 .19027 .23636 .31491 310.221 380.56)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe8d8a"
                transform="matrix(-.1859 .13953 .13428 .1789 392.435 480.627)"
              />
            </g>
          </g>
          <g>
            <path
              d="M491.23 520.522c3.058 1.203 14.49-8.474 13.78-11.916-.71-3.44-14.27-10.133-16.617-7.895-2.347 2.238-.218 18.607 2.838 19.811zM491.898 524.124c3.178-.84 13.31 7.343 12.205 10.62-1.106 3.277-13.828 10.615-17.555 6.74-2.205-2.293 2.173-16.52 5.35-17.36zM483.55 545.542c3.254-.312 9.834 7.751 7.99 11.946-1.39 3.164-16.567 6.006-19.995 1.864-2.028-2.452 7.931-13.419 12.004-13.81z"
              fill="#fd5d5a"
            />
          </g>
        </g>
        <g>
          <path d="M393.282 366.988c-6.524 1.492-14.32-3.643-14.45-2.721-.769 5.439 5.4 14.037 10.552 17.668l3.898-14.947zM643.105 340.459c6.666.357 13.55-5.88 13.822-5.014 1.607 5.113-3.132 14.42-7.644 18.77l-6.178-13.756z" />
          <circle
            cx={427.545}
            cy={531.3}
            r={27.325}
            transform="matrix(-1.04713 .02618 .02618 1.04713 1058.367 -207.253)"
          />
          <circle
            cx={427.545}
            cy={531.3}
            r={27.325}
            transform="matrix(-1.04713 .02618 .02618 1.04713 850.113 -185.905)"
          />
          <circle
            cx={437.886}
            cy={527.93}
            r={10.341}
            fill="#fff"
            transform="matrix(-1.04713 .02618 .02618 1.04713 1057.713 -208.795)"
          />
          <circle
            cx={437.886}
            cy={527.93}
            r={10.341}
            fill="#fff"
            transform="matrix(-1.04713 .02618 .02618 1.04713 849.055 -187.13)"
          />
          <g>
            <path
              d="M542.661 442.582c26.104-2.634 24.641-26.903 22.675-35.321-2.129-9.118-15.455-18.618-30.367-16.742-14.912 1.875-23.661 19.428-22.132 29.536 1.032 6.817 3.72 25.161 29.824 22.527z"
              fill="#fd6a66"
            />
            <g transform="matrix(.42121 -.05298 .06185 .49172 266.178 135.212)">
              <clipPath id="dino_coding_svg___clip5">
                <path d="M555.821 684.972c61.782 1.299 65.497-47.656 63.377-65.004-2.295-18.79-30.648-41.164-66.051-41.164-35.403 0-61.01 32.938-60.406 53.558.407 13.908 1.298 51.31 63.08 52.61z" />
              </clipPath>
              <g clipPath="url(#dino_coding_svg___clip5)">
                <path
                  d="M495.522 659.9c-13.479-14.932-36.92-47.825-34.467-63.24 5.568-35.009 64.265-22.855 96.397-22.855 32.133 0 90.83-12.154 96.398 22.855 3.586 22.547-18.602 61.453-45.778 78.605-8.165-17.377-26.836-34.745-57.647-39.194-30.486-4.403-42.739 9.608-54.903 23.83z"
                  fill="#d9413d"
                />
              </g>
            </g>
          </g>
        </g>
        <g transform="matrix(.84096 .49581 -.52804 .88172 -424.121 -1880.589)">
          <ellipse
            cx={2285.77}
            cy={1484.14}
            rx={64.646}
            ry={72.624}
            fill="#fea09d"
          />
          <clipPath id="dino_coding_svg___clip6">
            <ellipse cx={2285.77} cy={1484.14} rx={64.646} ry={72.624} />
          </clipPath>
          <g clipPath="url(#dino_coding_svg___clip6)">
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe908d"
              transform="matrix(-.46607 -.29571 .24567 -.40534 2509.61 1972.71)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe908d"
              transform="matrix(-.10159 -.32994 .32982 -.10397 2120.68 1733.19)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe908d"
              transform="matrix(.27533 -.15508 .16497 .30238 1916.5 1427.13)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe908d"
              transform="matrix(.28717 .15366 -.2183 .4177 2209.66 1060.33)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe908d"
              transform="matrix(.02833 -.22624 .2525 .03238 2114.38 1672.88)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8e8b"
              transform="matrix(-.35814 -1.52449 1.37263 -.33016 1569.65 2817.76)"
            />
            <g>
              <path
                d="M2316.374 1427.158c4.006-4.91-6.358-20.924-11.708-22.003-5.351-1.08-20.959 10.351-17.877 16.732 1.824 3.777 26.93 8.524 29.585 5.271zM2278.94 1417.526c.19-4.215-18.631-15.43-22.986-12.103-4.354 3.326-11.222 24.232-4.462 26.147 4 1.133 27.257-9.83 27.449-14.044zM2244.298 1440.032c-1.876-3.715-22.916-2.467-25.038 2.618-2.122 5.086 1.599 25.315 8.316 23.497 3.974-1.076 18.597-22.4 16.722-26.115z"
                fill="#fd6b67"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M410.178 425.575a11.499 11.499 0 0110.532-8.78l290.514-16.364a11.494 11.494 0 019.48 4.12 11.55 11.55 0 012.346 10.063c-8.563 35.419-29.755 123.133-36.374 150.51a11.499 11.499 0 01-10.532 8.78L385.64 590.267a11.494 11.494 0 01-9.479-4.12 11.49 11.49 0 01-2.346-10.063c8.562-35.428 29.755-123.133 36.363-150.509z"
            fill="#fff"
          />
          <g transform="matrix(-1.06198 .05982 .0529 .9392 4831.433 -1316.14)">
            <clipPath id="dino_coding_svg___clip7">
              <path d="M4242.15 1584.28c-1.38-5.16-5.58-8.69-10.35-8.69h-273.56c-3.42 0-6.64 1.83-8.68 4.94-2.03 3.1-2.65 7.11-1.67 10.82 9.91 37.08 34.44 128.91 42.1 157.57 1.38 5.16 5.58 8.69 10.35 8.69h273.55c3.42 0 6.64-1.83 8.68-4.94 2.04-3.1 2.66-7.12 1.67-10.82-9.91-37.09-34.44-128.91-42.09-157.57z" />
            </clipPath>
            <g clipPath="url(#dino_coding_svg___clip7)">
              <path
                d="M4238.605 1588.355c-1.38-5.16-5.58-8.69-10.35-8.69h-273.56c-3.42 0-6.64 1.83-8.68 4.94-2.03 3.1-2.65 7.11-1.67 10.82 9.91 37.08 34.44 128.91 42.1 157.57 1.38 5.16 5.58 8.69 10.35 8.69h273.55c3.42 0 6.64-1.83 8.68-4.94 2.04-3.1 2.66-7.12 1.67-10.82-9.91-37.09-34.44-128.91-42.09-157.57z"
                fill="#f0f0f0"
              />
            </g>
          </g>
        </g>
        <g transform="matrix(-.78313 .688 .6853 .7679 1126.766 -2125.518)">
          <ellipse
            cx={2285.77}
            cy={1484.14}
            rx={64.646}
            ry={72.624}
            fill="#fea19e"
          />
          <clipPath id="dino_coding_svg___clip8">
            <ellipse cx={2285.77} cy={1484.14} rx={64.646} ry={72.624} />
          </clipPath>
          <g clipPath="url(#dino_coding_svg___clip8)">
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe918e"
              transform="matrix(-.17957 -.5832 .48024 -.1514 2136.46 2020.09)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe918e"
              transform="matrix(-.10159 -.32994 .32982 -.10397 2157.41 1737.49)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe918e"
              transform="matrix(.1771 -.04934 .06119 .22484 2094.43 1415.17)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe918e"
              transform="matrix(.28717 .15366 -.2183 .4177 2180.72 1059.99)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe918e"
              transform="matrix(.03753 -.29964 .21905 .02809 2140.37 1672.18)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8f8c"
              transform="matrix(-.35814 -1.52449 1.37263 -.33016 1561.58 2823.87)"
            />
            <path
              d="M2316.374 1427.158c4.006-4.91-6.358-20.924-11.708-22.003-5.351-1.08-20.959 10.351-17.877 16.732 1.824 3.777 26.93 8.524 29.585 5.271zM2278.94 1417.526c.19-4.215-18.631-15.43-22.986-12.103-4.354 3.326-11.222 24.232-4.462 26.147 4 1.133 27.257-9.83 27.449-14.044zM2244.298 1440.032c-1.876-3.715-22.916-2.467-25.038 2.618-2.122 5.086 1.599 25.315 8.316 23.497 3.974-1.076 18.597-22.4 16.722-26.115z"
              fill="#fd6c68"
            />
          </g>
        </g>
        <g>
          <path
            d="M468.188 204.313c-3.627 15.432 34.91 54.915 44.955 46.902 10.046-8.013 32.424-71.982 8.698-92.414-14.225-12.25-49.122 26.23-53.653 45.512z"
            fill="#fd6a66"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgDinoCoding;
